import { createSlice, isAnyOf } from "@reduxjs/toolkit";

import { FooterDailyStatsAxios } from "../../axios/footer-daily-stats/footer-daily-stats.axios";
import { FooterDailyStats } from "../../model/footer-daily-stats/FooterDailyStats";
import { GetDailyFooterStatsDto } from "../../model/footer-daily-stats/dto/GetDailyFooterStatsDto";
import { GetFooterDailyStatsResponseDto } from "../../model/footer-daily-stats/dto/GetFooterDailyStatsResponseDto";
import { AtiraThunk } from "../AtiraThunk";
import { userActions } from "../user/user.slice";
import { revertAllReduxAction } from "../store-reset";

interface FooterReducer {
  footer: FooterDailyStats;
}

const initialState = Object.freeze<FooterReducer>({
  footer: {
    entries: {
      today: 0,
    },
    tasks: {
      lead: {
        today: 0,
      },
      contact: {
        today: 0,
      },
      kanban: {
        today: 0,
      },
    },
  },
});

const getFooterDailyStats = AtiraThunk<
  GetFooterDailyStatsResponseDto,
  GetDailyFooterStatsDto
>("/dashboard/footer/stats", FooterDailyStatsAxios.getDailyStats);

const footerSlice = createSlice({
  name: "footer-daily-stats",
  initialState,
  reducers: {},
  extraReducers: ({ addCase, addMatcher }) => {
    addCase(getFooterDailyStats.fulfilled, (state, action) => {
      state.footer = action.payload;
    });

    addMatcher(isAnyOf(userActions.logout, revertAllReduxAction), (state) => {
      return (state = initialState);
    });
  },
});

export const footerActions = {
  getFooterDailyStats,
};

export default footerSlice.reducer;
